export const state = () => ({
  title: '',
  description: '',
  ogUrl: '',
  ogImage: '',
  ogType: 'website',
  canonical: '',
  jsonLd: []
})

export const mutations = {
  set (state, meta) {
    state.title = meta.title || ''
    state.description = meta.description || ''
    state.ogUrl = meta.ogUrl || ''
    state.ogImage = meta.ogImage || ''
    state.ogType = meta.ogType || 'website'
    state.canonical = meta.canonical || ''
    state.jsonLd = meta.jsonLd || []
  },
  clear (state) {
    state.title = ''
    state.description = ''
    state.ogUrl = ''
    state.ogImage = ''
    state.ogType = 'website'
    state.canonical = ''
    state.jsonLd = []
  }
}

export const getters = {
  getMeta: state => state
}
